import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Modal from '@tls/ui-modal';

import { useMutationDeleteBranch } from '../../queries/utilities';
import { globalContextSelector } from '../../store/selectors';
import { connectionIdSelector } from '../../../shared/store/webSocketReducer';

interface deleteBranchModalProps {
  hideModal: () => void;
  visible: boolean;
}

const DeleteBranchModal = ({ hideModal, visible }: deleteBranchModalProps) => {
  const globalContext = useSelector(globalContextSelector);
  const { taxYear, period } = globalContext;
  const { mutateAsync: deleteBranch } = useMutationDeleteBranch();

  const connectionId = useSelector(connectionIdSelector);

  const onSubmitAction = useCallback(() => {
    // TODO: Temp loging

    if (!connectionId) {
      console.log('Missing connection id');
    }

    deleteBranch({ taxYear, period, connectionId: connectionId || '' });
    hideModal();
  }, [taxYear, period, deleteBranch, hideModal, connectionId]);

  return (
    <Modal
      title="Delete Branch Entity Returns"
      visible={visible}
      closeAction={hideModal}
      dismissText="Cancel"
      dismissAction={hideModal}
      submitText="Yes"
      submitAction={onSubmitAction}
    >
      <p>
        Are you sure you want to delete all returns associated with branch entities in this
        instance?
      </p>
    </Modal>
  );
};

export default DeleteBranchModal;
